import { connect } from 'react-redux';

import { setFlashSectionChoose } from '../actions/accountSettingsAction';
import {
  getContentByReference,
  getContentByWarfareQuals,
  resetChapterAction,
  resetChapterMessagge,
  setChapterId,
} from '../actions/studyMainActions';
import {
  getSwitchPfeSkt,
  getSwitchPfeSktWaiting,
} from '../components/AccountSettings/AccountSettingsSelectors';
import FlashcardComplete from '../components/Study/FlashcardComplete/flashcardComplete.jsx';
import {
  getChapterId,
  getContentByRefSelector,
  getContentByWarfareQualsSelector,
  getMoreQuestionsSelector,
  getQuestionSelector,
  getResetChapterMessage,
  isLoadingReferences,
  isStudyFavoriteQuestionSelector,
  isStudyingMyFavoriteQuestionsSelector,
  isStudyingMySubmittedQuestionsSelector,
  isStudyingSubmittedQuestionsSelector,
} from '../components/Study/studyMainSelectors';
import { getUser } from '../components/User/userSelectors';

const mapStateToProps = (state, ownProps) => ({
  contentByReferences: getContentByRefSelector(state),
  user: getUser(state),
  isLoadingContent: isLoadingReferences(state),
  contentByQuals: getContentByWarfareQualsSelector(state),
  question: getQuestionSelector(state),
  chapterId: getChapterId(state),
  messageResetChapter: getResetChapterMessage(state),
  isStudyFavoriteQuestion: isStudyFavoriteQuestionSelector(state),
  isStudyingSubmittedQuestions: isStudyingSubmittedQuestionsSelector(state),
  isStudyingMyFavoriteQuestions: isStudyingMyFavoriteQuestionsSelector(state),
  isStudyingMySubmittedQuestions: isStudyingMySubmittedQuestionsSelector(state),
  moreQuestions: getMoreQuestionsSelector(state),
  pfeSktId: getSwitchPfeSkt(state),
  pfeSktIdWaiting: getSwitchPfeSktWaiting(state),
});
const mapDispatchToProps = (dispatch) => ({
  getContentByReference: (rate) => dispatch(getContentByReference(rate)),
  getByWarfareQuals: (rate) => dispatch(getContentByWarfareQuals(rate)),
  resetChapter: (data) => dispatch(resetChapterAction(data)),
  setChapterId: (chapterId) => dispatch(setChapterId(chapterId)),
  resetChapterMessagge: (message) => dispatch(resetChapterMessagge(message)),
  setFlashSectionChoose: (value) => dispatch(setFlashSectionChoose(value)),
});

const FlashcardCompleteContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FlashcardComplete);

export default FlashcardCompleteContainer;
